/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Tut_TocInputs */

const en_fc_tut_toc = /** @type {(inputs: Fc_Tut_TocInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Steps`)
};

/**
* | output |
* | --- |
* | "Steps" |
*
* @param {Fc_Tut_TocInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_tut_toc = /** @type {((inputs?: Fc_Tut_TocInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Tut_TocInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_tut_toc(inputs)
});
export { fc_tut_toc as "fc.tut.toc" }